import dayjs, { Dayjs } from 'dayjs';
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

/**
 * Converts various date formats to a Dayjs object
 * @param date - Can be a Dayjs object, Date object, ISO string, or timestamp
 * @returns A valid Dayjs object
 * @throws Error if the date cannot be converted or is invalid
 */
export function ensureDayjs(date: Dayjs | Date | string | number | undefined | null): Dayjs {
    if (!date) {
        throw new Error('Date is required but was undefined or null');
    }
    
    // Already a Dayjs object
    if (date && typeof date === 'object' && typeof (date as any).utc === 'function') {
        return date as Dayjs;
    }
    
    // Convert from string, Date, or number
    let dayjsTime: Dayjs;
    
    if (typeof date === 'string' || date instanceof Date || typeof date === 'number') {
        dayjsTime = dayjs(date);
        if (!dayjsTime.isValid()) {
            throw new Error(`Invalid date: ${date}`);
        }
        return dayjsTime;
    }
    
    throw new Error(`Unexpected date type: ${typeof date}`);
}

/**
 * Converts an array of dates to Dayjs objects
 * @param dates - Array of dates in various formats
 * @returns Array of Dayjs objects
 */
export function ensureDayjsArray(dates: any[]): Dayjs[] {
    if (!Array.isArray(dates)) {
        throw new Error('Expected an array of dates');
    }
    return dates.map(date => ensureDayjs(date));
}